module.exports = __webpack_public_path__ + "static/media/preorder.08ebd589.svg";